import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AddressService {

  private readonly BAN_API_URL = 'https://api-adresse.data.gouv.fr/search/';

  constructor(private http: HttpClient) {}

  search(query: string): Observable<any[]> {
    if (!query || query.trim().length < 3) {
      return Observable.of([]);
    }
    const url = `${this.BAN_API_URL}?q=${encodeURIComponent(query)}&type=housenumber&limit=5`;
    return this.http.get(url).map((response: any) => response.features || []);
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/services/address.service.ts